import { createSlice } from "@reduxjs/toolkit";

let initialState = {
  userDetails: null
};
export const userDetailsSlice = createSlice({
  name: "userdetails",
  initialState,
  reducers: {
    setUserDetails: (state, action) => {
      state.userDetails = {...action.payload};
    },
    updateUserDetails: (state, action) => {
      state.userDetails = { ...state.userDetails, ...action.payload };
    }    
  },
});
export const {
  setUserDetails,
  updateUserDetails
} = userDetailsSlice.actions;
export default userDetailsSlice.reducer;
